export default {
    meta: {
        title: '拓店宝-拓店任务详情',
        url: '/task',
        urlName: '拓店任务'
    }
};
